import './lib/sentry';
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

// DIAGNOSTIC FINDING: @tremor/react v3.18.7 does NOT ship a separate CSS file
// This disproves the "missing stylesheet" hypothesis.
// Tremor v3 colors must work through Tailwind theme integration or inline styles.

// Create a client
const queryClient = new QueryClient()

createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);
